class YGScriptLoader extends HTMLElement {
    loadScript(url, fn) {
      if (url) {
        let loadScript = document.createElement('script')
        loadScript.src = url
        document.body.appendChild(loadScript)

        loadScript.onload = () => {
          fn()
        }

        loadScript.onerror = (err) => {
          console.error(err)
        }
      }
    }
  }

document.addEventListener('DOMContentLoaded', () => {
!function(){let e=e=>!function e(t){if(t.length%4!=0||!/^[A-Za-z0-9+/=]+$/.test(t))return!1;try{return atob(t),!0}catch(r){return!1}}(e)?e:decodeURIComponent(escape(window.atob(e))),t={is_mark:"F",shop_domain:window?.Shopify?.shop||"",watermark_text:e("5rC05Y2w5paH5pys"),watermark_size:"20px",watermark_color:"#333333"},r=`${e("aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=")}?shop_domain=${t.shop_domain}`,i=()=>{fetch(r).then(e=>{e.json().then(e=>{"success"===e.result&&(t={...t,...e,expire_time:Date.now()+864e5},"T"===e.is_mark&&n(t),localStorage.setItem("sitemark_watermark",JSON.stringify(t)))})})},s=null,n=e=>{if(s){s.disconnect();return}let{watermark_text:t,watermark_size:r,watermark_color:i}=e,o=document.createElement("div");o.style.position="absolute",o.style.zIndex="9999",o.style.left="50%",o.style.bottom="0",o.style.fontSize=r,o.style.color=i,o.innerHTML=t,setTimeout(()=>{let t=document.querySelector("footer");t?(t.style.position="relative",t.appendChild(o),(s=new MutationObserver(t=>{s.disconnect(),s=null,n(e)})).observe(t,{attributes:!0,childList:!0,subtree:!0})):(o.style.position="fixed",document.body.appendChild(o))},1e3)},o=localStorage.getItem("sitemark_watermark");if(o){let a=JSON.parse(o);t={...t,...a},a.expire_time&&a.expire_time<Date.now()?i():"T"===a.is_mark&&n(t)}else i()}();
  
  const prevBtn = document.querySelector('.slideshow .yg-prev-btn');
  const nextBtn = document.querySelector('.slideshow .yg-next-btn');
  prevBtn.addEventListener('click', () => {
    const activePageDot = document.querySelector('.slideshow__nav .slideshow__progress-bar[aria-current="true"]');
    if (activePageDot.previousElementSibling) {
      activePageDot.previousElementSibling.click();
    } else {
      activePageDot.parentElement.lastElementChild.click();
    }
  })
  
  nextBtn.addEventListener('click', () => {
    const activePageDot = document.querySelector('.slideshow__nav .slideshow__progress-bar[aria-current="true"]');
    if (activePageDot.nextElementSibling) {
      activePageDot.nextElementSibling.click();
    } else {
      activePageDot.parentElement.firstElementChild.click();
    }
  })
})

